import React from "react";
;
export var SortLabel = function (_a) {
    var active = _a.active, onClick = _a.onClick, children = _a.children, _b = _a.direction, direction = _b === void 0 ? 'asc' : _b;
    return (React.createElement("span", { className: "sort-label  " + (active ? 'active' : ''), onClick: onClick },
        children,
        React.createElement("svg", { className: "direction " + direction, focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
            React.createElement("path", { d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z" }))));
};
